import React from "react";
import { HiMiniCheckBadge } from "react-icons/hi2";
import { Link } from "react-router-dom";

// Custom Components
import { Heading1, Heading2, Button1 } from "../../../components/Ui";
import bannerBg from '../../../assets/img/landing-page/landing-page-bg.png';

// Images
import images from "../B2BDatabase/images";
import B2bdatabaseHome from "./components/home";
import LandingPageTestimonial from "../../../components/landingPageTestimonial/landingPageTestimonial";
import B2bFaqs from "./components/b2bfaq";
const B2bdatabase = () => {
  return (
    <div className="main-body">
      <div style={{ position: "relative", zIndex: 1 }}>
        {/* Section */}
        <section
          style={{
            backgroundImage: `url(${bannerBg})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "center",
            backgroundSize: "cover",
            paddingTop: "3rem", // Adjust spacing above the text column
            paddingBottom: "6rem",
            position: "relative", // Ensure the section context for the overlapping image
          }}
        >
          {/* Text Column */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "1rem",
              alignItems: "center",
              justifyContent: "center",
              textAlign: "center",
              marginTop: "50px", // Push text column down slightly
            }}
          >
            <div>
              <Heading1 heading1="Unlock the Power of Our B2B Database" />
            </div>
            <Heading2 heading2="50M Companies & 500M Contacts" />
            <Link to="/">
              <Button1 btn1="Try free B2B Database" />
            </Link>
            <ul
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "1rem",
                justifyContent: "center",
                listStyle: "none",
                padding: 0,
              }}
            >
              <li
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                  fontSize: "12px",
                  fontWeight: "normal",
                  gap: "0.5rem",
                }}
              >
                <HiMiniCheckBadge /> Real-time email verifications
              </li>
              <li
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                  fontSize: "12px",
                  fontWeight: "normal",
                  gap: "0.5rem",
                }}
              >
                <HiMiniCheckBadge /> More than 15 filtering options
              </li>
              <li
                style={{
                  display: "flex",
                  alignItems: "center",
                  textAlign: "center",
                  fontSize: "12px",
                  fontWeight: "normal",
                  gap: "0.5rem",
                }}
              >
                <HiMiniCheckBadge /> New Load Alerts
              </li>
            </ul>
          </div>
        </section>

        {/* Overlapping Image */}
        <div
          style={{
            marginTop: "-60px", // Pull the image up to overlap the section
            textAlign: "center", // Center the image
            zIndex: 2, // Ensures image is above the section
            position: "relative", // Allow overlap without affecting layout
          }}
        >
          <img
            src={images.home}
            alt="my-img"
            style={{
              width: "60%", // Control image size
              height: "auto",
            }}
          />
        </div>       
      </div>

      <B2bdatabaseHome />
      <div style={{ paddingBottom: 0, marginTop: "25px" }}>
          <B2bFaqs />
        </div>
      <div style={{ paddingBottom: 0, marginTop: "25px" }}>
          <LandingPageTestimonial />
        </div>
    </div>
  );
};

export default B2bdatabase;
